import React from 'react';

/** Stylised arm + dumbbell mark — original vector, not a stock trace */
export default function LogoMark({ className = '' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M14 32c-2-4-1-9 2-12l4-3c2-1 4 0 5 2l2 5c1 2 0 4-2 5l-3 2c-3 2-6 3-8 1z"
        fill="currentColor"
        opacity="0.9"
      />
      <path
        d="M20 18c3-5 8-8 14-7 2 0 3 2 3 4l-1 6c0 2-2 3-4 3h-2l-6-2c-2-1-3-3-4-4z"
        fill="currentColor"
      />
      <rect x="28" y="22" width="14" height="6" rx="1.5" fill="currentColor" />
      <rect x="40" y="19" width="3" height="12" rx="1" fill="currentColor" />
      <circle cx="41.5" cy="25" r="2" fill="#0a0a0a" opacity="0.35" />
    </svg>
  );
}
